const CLOUDINARY_BASE_URL = 'https://img.chirpbooks.com/image';

export const CdnImageUtils = {
  fetchOptimizedImage(imageUrl, otherTransformations = null, optimize = true) {
    const urlParts = [CLOUDINARY_BASE_URL, 'fetch'];

    // Encode the remote URL being fetched to preserve query params
    const encodedImageUrl = escape(imageUrl);

    // Add Cloudinary transformations as a URI path value
    const optimizations = [];
    if (optimize) {
      optimizations.push(['f_auto', 'q_auto']);
    }
    if (otherTransformations) {
      optimizations.push(otherTransformations);
    }
    if (!_.isEmpty(optimizations)) {
      urlParts.push(_.join(optimizations, ','));
    }

    return _.join(_.concat(urlParts, encodedImageUrl), '/');
  },

  getOptimizedImage(imageSlug, otherTransformations = null, optimize = true) {
    const urlParts = [CLOUDINARY_BASE_URL, 'upload'];

    const optimizations = [];
    if (optimize) {
      optimizations.push(['q_auto', 'f_auto']);
    }
    if (otherTransformations) {
      optimizations.push(otherTransformations);
    }
    if (!_.isEmpty(optimizations)) {
      urlParts.push(_.join(optimizations, ','));
    }

    return _.join(_.concat(urlParts, imageSlug), '/');
  },

  getCloudinarySlug(imageUrl) {
    // match on everything starting with the version (removes old transforms)
    const urlMatches = [
      /https?:\/\/img.chirpbooks.com\/image\/upload\/(?:.*\/)?(v\d+\/.*)/,
      /https?:\/\/res.cloudinary.com\/(?:chirp.*)?image\/upload\/(?:.*\/)?(v\d+\/.*)/,
    ];
    const matchedUrlGroups = imageUrl.match(urlMatches[0]) || imageUrl.match(urlMatches[1]);
    return matchedUrlGroups ? matchedUrlGroups[1] : null;
  },
};
